module.exports = "<ion-popover-view>\r\n    <a\r\n        class=\"item dropdown\"\r\n        ng-click=\"$ctrl.closePopover(option)\"\r\n        ng-repeat=\"option in $ctrl.options\"\r\n    >\r\n        <i\r\n            ng-style=\"{'color': option.color}\"\r\n            ng-if=\"option.icon\"\r\n            class=\"{{option.icon}}\"\r\n        ></i>\r\n        {{ option.name | translate }}\r\n    </a>\r\n</ion-popover-view>\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/directives/popovers/dropdownTemplate.html
 ** module id = 393
 ** module chunks = 0
 **/